import { makeAutoObservable } from "mobx";
import { ResourcesList } from "generated";

export interface DroppedImage {
  id: string;
  src: string;
  x: number;
  y: number;
  linkedElementId?: string;
  propertysubtypes?: string;
  setvalue?: string;
  top?: number;
  left?: number;
  priority: number;
  height: number;
  width: number;
  timestamp: number;
  group?: string;
  origin?: "mark" | "poster";
  linkSide?: string;
  controlId?: string;
  hidden?: boolean;
  targetSide?: "left" | "right" | "top" | "bottom";
  comment: string;
  commentDate: any;
  commentAuthor: string;
  windowId: any;
}

export type Mark = {
  id: string;
  name: string;
  text?: string;
}

export type CommentInfo = {
  text: string;
  user: string;
  timestamp: string;
}

export class MarkStore {
  marks: any[] = [];
  notes: any[] = [];
  droppedImages: DroppedImage[] = [];
  deletedImages: DroppedImage[] = [];
  comments: Map<string, CommentInfo> = new Map();
  isOpen: boolean = false;
  selectedMark: Mark | null = null;
  selectMark(mark: Mark) {
    this.selectedMark = mark;
  }
  allHidden = false;
  imageLogs: Map<string, {user: string; timestamp: string }> = new Map();
  imageGroups: DroppedImage[][] = [];
  connectionlinecolor: string = "#216aff";
  selectionoutlinecolor: string = "#216aff";
  connections: Map<string, HTMLElement> = new Map();
  activeImageId: string | null = null;
  isMarkControl: boolean = true;
  id: string;


  constructor() {
    makeAutoObservable(this);
  }

  areImagesOverlapping(a: DroppedImage, b: DroppedImage) {
    const ax = a.left ?? a.x;
    const ay = a.top ?? a.y;
    const aw = a.width ?? 200;
    const ah = a.height ?? 100;

    const bx = b.left ?? b.x;
    const by = b.top ?? b.y;
    const bw = b.width ?? 200;
    const bh = b.height ?? 100;

    return ax < bx + bw &&
          ax + aw > bx &&
          ay < by + bh &&
          ay + ah > by;
  }

  openModal(posters: Mark[] = [], notes: Mark[] = []) {
    this.marks = posters; 
    this.notes = notes; 
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }

  toJSON() {
    return {
      id: this.id,
      droppedImages: this.droppedImages.map(img => ({ ...img })),
      deletedImages: this.deletedImages.map(img => ({ ...img })),
      comments: Array.from(this.comments.entries()),
    };
  }

  hydrateFromJSON(data: any) {
    this.droppedImages = data.droppedImages || [];
    this.deletedImages = data.deletedImages || [];
    this.comments = new Map(data.comments || []);
  }

  removeImage(img: DroppedImage) {
    if (!this.deletedImages.some(d => this.same(d, img))) {
      this.deletedImages.push(img);
    }
  }

  findMarkBySrc(src: string) {
    const cleanSrc = src.replace("/resources/", "");
    const entry = Object.entries(ResourcesList.resourcesList).find(
      ([, value]) => value === cleanSrc
    );

    if (!entry) return undefined;
    const [resourcename] = entry;
    const shortName = resourcename.split(".").pop()?.replace(/^\d+_ /, "") || "Без названия";

    return {
      name: shortName,
      resourcename
    };
  }

  isDeleted(img: DroppedImage) {
    return this.deletedImages.some(d => this.same(d, img));
  }

  private same(a: DroppedImage, b: DroppedImage): boolean {
    return a.src === b.src && a.x === b.x && a.y === b.y;
  }

  onChange = <T extends keyof MarkStore>(
      name: T,
      value: MarkStore[T]
    ) => {
      this[name] = value as never;
    };
}

export class MarkData {
  marksData:any[] = [];
}

export const markStore = new MarkStore();
export const marksData = new MarkData();

